import { message } from 'antd';
import classNames from 'classnames';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import { getFeedbackSuggest, getSearchResult, setFeedbackSuggest } from '../../actions/search';
import CardIndex from '../../card/CardIndex/CardIndex';
import ALineCard from '../../components/ALineCard/ALineCard';
import CommReco from '../../components/CommReco/CommReco';
import LineCard from '../../components/LineCard/LineCard';
import LineCardDReco from '../../components/LineCardDReco/LineCardDReco';
import Loading from '../../components/Loading/Loading';
import fail from '../../static/msg-fail.svg';
import success from '../../static/msg-success.svg';
import { getQueryString } from '../../utils/utils';
import styles from './SearchResult.module.less';

const selectSearchRecommend = createSelector(
  state => state.search,
  search => search.searchRecommend,
);
const selectSearchResult = createSelector(
  state => state.search,
  search => search.searchResult,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectFeedbackSuggest = createSelector(
  state => state.search,
  search => search.feedbackSuggest,
);
const selectSearchKw = createSelector(
  state => state.layout,
  layout => layout.searchKw,
);

export default function SearchResult() {
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const [feedbackSuggestRef, setFeedbackSuggestRef] = useState(null);
  const [feedbackSuggestcontent, setFeedbackSuggestcontent] = useState(null);
  // const location = useLocation();
  const dispatch = useDispatch();
  const searchResult = useSelector(selectSearchResult);
  const searchRecommend = useSelector(selectSearchRecommend);
  const logInfoData = useSelector(selectLogInfo);
  const feedbackSuggest = useSelector(selectFeedbackSuggest);

  const keyword = getQueryString('keyword');
  const firstId = getQueryString('firstId');
  const androidType = getQueryString('androidType');
  const searchKw = useSelector(selectSearchKw);
  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Search`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
            keyword,
            firstId,
            androidType,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    if (
      !searchResult ||
      searchResult.params.loading !== false ||
      searchResult.params.softName !== keyword
    ) {
      dispatch(getSearchResult({ keyword, firstId, androidType }));
    } else {
      // 搜索结果页面数据展示
      dispatch(
        logging({
          category: 'R',
          action: 'SearchResult',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            has_content: searchResult.count > 0 ? 1 : 0,
            search_type: logInfoData.search_type,
            search_word: logInfoData.search_word,
            keyword,
          },
          param3: searchResult.bizInfo,
        }),
      );
    }
  }, [dispatch, keyword, searchResult]);

  useEffect(() => {
    // 搜索结果页面PV打桩
    dispatch(
      logging({
        category: 'P',
        action: 'Search',
        label: '',
        param2: {
          source: 'Search',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: logInfoData.search_word,
          keyword,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Search',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);
  const handleFeedback = useCallback(() => {
    if (!feedbackVisible) {
      // 翻页打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Feedback',
          label: '',
          param2: {
            source: 'Search',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      message.destroy();
    }
    if (feedbackVisible) {
      setFeedbackSuggestcontent(null);
    }
    setFeedbackVisible(!feedbackVisible);
  }, [feedbackVisible]);

  const handleFeedbackSuggest = useCallback(() => {
    const messages = feedbackSuggestRef.value;
    if (!messages) {
      return;
    }
    dispatch(
      getFeedbackSuggest({
        message: messages,
        searchWord: searchKw,
      }),
    );
  }, [feedbackSuggestRef, searchKw]);

  useEffect(() => {
    if (feedbackSuggest) {
      if (feedbackSuggest.status === 0) {
        handleFeedback();
      }

      message.success({
        content: feedbackSuggest.status === 0 ? '提交成功！' : '提交失败，请稍后再试!',
        className: 'ant-message-notice-center',
        icon: (
          <img
            className="ant-message-custom-img"
            src={feedbackSuggest.status === 0 ? success : fail}
            alt="success"
          />
        ),
        duration: 5,
      });
      dispatch(
        setFeedbackSuggest({
          feedbackSuggest: null,
        }),
      );
    }
  }, [feedbackSuggest]);

  const handleTextArea = useCallback(() => {
    setFeedbackSuggestcontent(
      feedbackSuggestRef && feedbackSuggestRef.value && feedbackSuggestRef.value.slice(0, 300),
    );
    if (
      feedbackSuggestRef &&
      feedbackSuggestRef.value &&
      feedbackSuggestRef &&
      feedbackSuggestRef.value.length > 300
    ) {
      feedbackSuggestRef.value = feedbackSuggestRef.value.slice(0, 300);
      message.error({
        content: '您反馈的内容过多，请将字数控制在300字以内!',
        icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        duration: 5,
      });
    }
  });

  const handleSearchOut = () => {
    window.open(`https://www.baidu.com/s?wd=${keyword}`);
    dispatch(
      logging({
        category: 'C',
        action: 'Search_To_Browser',
        label: '',
        param2: {
          source: 'Search',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_word: logInfoData.search_word,
          keyword,
          search_type: logInfoData.search_type,
        },
      }),
    );
  };

  return (
    <>
      {(!searchResult ||
        (searchResult && searchResult.params && searchResult.params.softName !== keyword)) && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
      {searchResult && searchResult.apps && searchResult.apps.length > 0 && (
        <div className={styles.searchresult}>
          <div className="sumary">
            共搜到
            <span className="count">{searchResult.count > 30 ? 30 : searchResult.count}</span>款软件
            {/* <span className="point">手机版可在电脑上直接安装</span> */}
            <span className="feedback" onClick={handleFeedback}>
              <i className="iconfont icon-feedback1 feedback_icon" />
              搜索反馈
            </span>
          </div>
          <div className="list">
            {searchResult.apps.map((soft, i) => {
              if (soft.itemType === 1 || soft.itemType === 2) {
                return soft.androidType === '1' ? (
                  <React.Fragment key={i}>
                    <ALineCard logInfo={{ source: 'Search', isSearch: true }} soft={soft} key={i} />
                    {searchRecommend[soft.packageName] &&
                      searchRecommend[soft.packageName].apps &&
                      searchRecommend[soft.packageName].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={searchRecommend[soft.packageName]}
                          logInfo={{
                            source: `Search|| ||DReco||${soft.packageName}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                          }}
                        />
                      )}
                  </React.Fragment>
                ) : (
                  <React.Fragment key={i}>
                    <LineCard
                      logInfo={{ source: 'Search', isSearch: true }}
                      soft={soft}
                      info={{ isCompetitive: true }}
                    />
                    {searchRecommend[soft.softID] &&
                      searchRecommend[soft.softID].apps &&
                      searchRecommend[soft.softID].apps.length > 4 && (
                        <LineCardDReco
                          recommendData={searchRecommend[soft.softID]}
                          logInfo={{
                            source: `Search|| ||DReco||${soft.softID}`,
                            source_p: logInfoData.source_p,
                            source_pp: logInfoData.source_pp,
                            search_type: logInfoData.search_type,
                            search_word: keyword,
                            isSearch: true,
                          }}
                        />
                      )}
                  </React.Fragment>
                );
              }
              if (soft.itemType === 3) {
                return <CardIndex data={soft} key={i} logInfo={{ tag: 'Search' }} />;
              }
              return '';
            })}

            <div className={styles.search_out} onClick={handleSearchOut}>
              没找到满意结果？试试{' '}
              <span className={styles.search_out_text}>
                百度搜索 &quot;{keyword}&quot;&nbsp;&gt;
              </span>
            </div>
          </div>
        </div>
      )}
      {searchResult && searchResult.count === 0 && (
        <div className={styles.Nosearchresult}>
          <div className="NosearchresultBox">
            <div className="noresultImg" />
            <div className="mainTextWrap">
              <div className="mainText" onClick={handleSearchOut}>
                没找到匹配结果。试试&nbsp;
                <span className={styles.search_out_text}>
                  百度搜索 &quot;{keyword}&quot;&nbsp;&gt;
                </span>
                <br />{' '}
              </div>
            </div>
            <div className={styles.feedback_btn} onClick={handleFeedback}>
              搜索反馈
            </div>
          </div>
        </div>
      )}
      <CommReco logInfo={{ tag: 'Search' }} />
      {feedbackVisible && (
        <div className={styles.mask}>
          <div className={styles.feedback_modal}>
            <div className={styles.feedback_close} onClick={handleFeedback}>
              <i className="iconfont icon-close" />
            </div>
            <div className={styles.feedback_title}>搜索反馈</div>
            <textarea
              className={styles.feeedback_suggest}
              ref={r => setFeedbackSuggestRef(r)}
              onChange={handleTextArea}
              // maxLength={300}
              placeholder="找不到您要的软件？将您要找的软件或遇到的搜索问题反馈给我们，我们将不断补充优化。"
            />
            <div
              className={classNames(styles.feedback_submit_btn, {
                [styles.feedback_submit_btn_disabled]: !feedbackSuggestcontent,
              })}
              onClick={handleFeedbackSuggest}
            >
              发送
            </div>
            <div className={styles.count}>
              {(feedbackSuggestcontent && feedbackSuggestcontent.length) || 0}
              /300
            </div>
          </div>
        </div>
      )}
    </>
  );
}
